import { SHOW_MODAL, CLOSE_MODAL } from '../reducers/modal';

export function showModalObject(text: string) {
    return {
        type: SHOW_MODAL,
        text
    };
}

export function showModal(text: any) {
    return (dispatch: any) => {
        dispatch(showModalObject(text));
    }
}

function closeModalObject() {
    return {
        type: CLOSE_MODAL
    };
}

export function closeModal() {
    return (dispatch: any) => {
        dispatch(closeModalObject());
    }
}